module.exports = "/assets/738c79f3801a88ebc50358d62ba041e5.svg";